module.exports = __webpack_public_path__ + "static/img/bg-id.66d6f0f5.png";